export function delayAsync(timeout: number) {
  return timeout <= 0
    ? Promise.resolve()
    : new Promise(resolve => {
        setTimeout(resolve, timeout);
      });
}
